<template>
  <div>
    <!-- Add overlay div that appears when chatbot is open -->
    <div v-show="isChatbotOpen" class="chatbot-overlay" @click="closeChatbot"></div>
    
    <button class="chatbot-trigger" :class="{ 'chat-ai': typeBtn === 'CHAT_AI' }" @click="toggleChatbot">
      <div class="icon-container">
        <img v-if="!isChatbotOpen" :src="typeBtn === 'CHAT_AI' ? require('@/assets/images/chatbot-o.png') : require('@/assets/images/chatbot8.svg')" alt="Open Chat" class="trigger-icon">
        <img v-else src="@/assets/images/chatbot7.svg" alt="Close Chat" class="trigger-icon trigger-icon-close">
      </div>
    </button>
    
    <!-- Simplified transition -->
    <transition name="simple-fade">
      <div v-show="isChatbotOpen" class="chatbot-container">
        <!-- FAQ Chatbot -->
        <Chatbot v-show="typeBtn === 'FAQ'" @close="closeChatbot" />
        
        <!-- AI Chatbot with iframe -->
        <div v-show="typeBtn === 'CHAT_AI'" class="ai-chatbot-wrapper">
          <iframe 
            :src="chatAiUrl" 
            class="ai-chatbot-frame"
            frameborder="0"
            allow="microphone; camera"
          ></iframe>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Chatbot from './Chatbot.vue';
import LocalStorage from '@/ultils/local-storage'

export default {
  name: 'ChatbotButton',
  components: {
    Chatbot
  },
  props: {
    typeBtn: {
      type: String,
      default: 'FAQ',
      validator: (value) => ['FAQ', 'CHAT_AI'].includes(value)
    }
  },
  data() {
    return {
      isChatbotOpen: false
    }
  },
  computed: {
    chatAiUrl() {
      return 'https://chatbot.unitel.com.la:8101/?lang='+LocalStorage.getItem('lang')
      // return process.env.VUE_APP_CHAT_AI_URL || 'http://183.182.118.28:8101/unitel-bot-sales'
    }
  },
  methods: {
    toggleChatbot() {
      this.isChatbotOpen = !this.isChatbotOpen;
    },
    closeChatbot() {
      this.isChatbotOpen = false;
    }
  }
}
</script>

<style scoped>
/* Add overlay styles */
.chatbot-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
  z-index: 1000; /* Just below the chatbot button but above other content */
  /* animation: fade-in 0.3s ease-out; */
}

/* @keyframes fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
} */

.chatbot-trigger {
  position: fixed;
  bottom: 110px; 
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #F6601B;
  color: white;
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2000;
  transition: transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275), 
              background-color 0.3s ease, 
              box-shadow 0.3s ease;
  overflow: hidden;
  will-change: transform, background-color, box-shadow;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  transition: transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  will-change: transform;
}

.trigger-icon {
  width: 15px;
  height: 15px;
  object-fit: contain;
  transition: opacity 0.25s ease, transform 0.35s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  will-change: opacity, transform;
}

/* Chỉ CHAT_AI có kích thước 30px */
.chatbot-trigger.chat-ai .trigger-icon {
  width: 30px;
  height: 30px;
}
.trigger-icon-close {
  width: 15px !important;
  height: 15px !important;
}

.chatbot-trigger:hover {
  background-color: theme('colors.orange.chatHover');
  transform: scale(1.08);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.chatbot-trigger:hover .icon-container {
  transform: rotate(8deg);
}

.chatbot-trigger:active {
  transform: scale(0.92);
  transition: transform 0.15s ease;
}

/* Animation for the chatbot */
.fade-slide-enter-active {
  transition: all 0.3s ease-out;
}

.fade-slide-leave-active {
  transition: all 0.25s ease-in;
}

.fade-slide-enter-from, 
.fade-slide-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  transform: translateY(0);
  opacity: 1;
}

.chatbot-container {
  position: fixed;
  bottom: 170px;
  right: 20px;
  z-index: 1500;
}

/* Remove problematic AI-specific styles that affect FAQ */
.ai-chatbot-wrapper {
  width: 350px;
  height: 500px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.ai-chatbot-frame {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
  border-radius: 12px;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .ai-chatbot-wrapper {
    width: calc(100vw - 40px);
    height: 500px;
  }
  
  .chatbot-container {
    right: 20px;
    left: 20px;
  }
}

.simple-fade-enter-active, .simple-fade-leave-active {
  transition: opacity 0.3s ease;
}
.simple-fade-enter-from, .simple-fade-leave-to {
  opacity: 0;
}
</style>